import Vue from "vue";
import Router from "vue-router";
import Orders from "@/pages/Orders";
import Reports from "@/pages/Reports";
import Login from "@/pages/Login";
import Terminals from "@/pages/Terminals";
import Dashboard from "@/pages/Dashboard";
import Splits from "@/pages/Splits";
import Finance from "@/pages/Finance";
import Settings from "@/pages/Settings";
import NotFound from "@/pages/NotFound";
import Callback from "@/pages/Callback";
import VtbAuth from "@/pages/VtbAuth";
import UralsibAuth from "@/pages/UralsibAuth";

//  Settings
import s_Users from "@/components/settings/Users";
import s_AddUser from "@/components/settings/AddUser";
import s_EditUser from "@/components/settings/EditUser";

import s_Merchants from "@/components/settings/Merchants/Merchants";
import s_AddMerchant from "@/components/settings/Merchants/AddMerchant";
import s_EditMerchant from "@/components/settings/Merchants/EditMerchant";

import s_Processings from "@/components/settings/Processings/Processings";
import s_AddProcessing from "@/components/settings/Processings/AddProcessing";
import s_EditProcessing from "@/components/settings/Processings/EditProcessing";

import s_Terminals from "@/components/settings/Terminals";

import s_Whitelist from "@/components/settings/Whitelist/Whitelist";
import s_AddWhitelist from "@/components/settings/Whitelist/AddWhitelist";
import s_DeleteWhitelist from "@/components/settings/Whitelist/DeleteWhitelist";

import store from "../store";

import { pathname } from "../api/apiUrl.js";

import axios from "axios";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: pathname,
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: "orders"
    },
    {
      name: "Login",
      path: "/login",
      component: Login
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback
    },
    {
      path: "/orders",
      name: "Orders",
      component: Orders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/splits",
      name: "Splits",
      component: Splits,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        requiresRights: false
      }
    },
    {
      path: "/reports",
      name: "Reports",
      component: Reports,
      meta: {
        requiresAuth: true,
        requiresRights: false
      }
    },
    {
      path: "/terminals",
      name: "Terminals",
      component: Terminals,
      meta: {
        requiresAuth: true,
        requiresRights: false
      }
    },
    {
      path: "/finance",
      name: "Finance",
      component: Finance,
      meta: {
        requiresAuth: true,
        requiresRights: true
      }
    },
    {
      path: "/vtb-auth",
      name: "VtbAuth",
      component: VtbAuth,
      meta: {
        requiresAuth: true,
        requiresRights: false
      }
    },
    {
      path: "/uralsib-auth",
      name: "UralsibAuth",
      component: UralsibAuth,
      meta: {
        requiresAuth: true,
        requiresRights: false
      }
    },
    {
      path: "/settings",
      name: "Settings",
      redirect: "/settings/users",
      component: Settings,
      meta: {
        requiresAuth: true,
        requiresRights: true
      },
      children: [
        {
          path: "users",
          name: "s_Users",
          component: s_Users
        },
        {
          path: "users/:id",
          name: "s_EditUser",
          component: s_EditUser
        },
        {
          path: "create_user",
          name: "s_AddUser",
          component: s_AddUser
        },
        {
          path: "merchants",
          name: "s_Merchants",
          component: s_Merchants
        },
        {
          path: "create_merchant",
          name: "s_AddMerchant",
          component: s_AddMerchant
        },
        {
          path: "merchants/:id",
          name: "s_EditMerchant",
          component: s_EditMerchant
        },
        {
          path: "whitelist",
          name: "s_Whitelist",
          component: s_Whitelist
        },
        {
          path: "create_whitelist",
          name: "s_AddWhitelist",
          component: s_AddWhitelist
        },
        {
          path: "delete_whitelist",
          name: "s_DeleteWhitelist",
          component: s_DeleteWhitelist
        },
        {
          path: "terminals",
          name: "s_Terminals",
          component: s_Terminals
        },
        {
          path: "processings",
          name: "s_Processings",
          component: s_Processings
        },
        {
          path: "create_processing",
          name: "s_AddProcessing",
          component: s_AddProcessing
        },
        {
          path: "processings/:id",
          name: "s_EditProcessing",
          component: s_EditProcessing
        }
      ]
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("Authorization-Token") != "" && !store.getProfile) {
    axios.defaults.headers.common["Authorization-Token"] = localStorage.getItem(
      "Authorization-Token"
    );
    store.dispatch("USER_REQUEST");
  }

  // Allow finishing callback url for logging in
  if (to.matched.some(record => record.path == "/callback")) {
    store.dispatch("AUTH_HANDLE");
    next(false);
  }

  let routerAuthCheck = false;
  if (
    localStorage.getItem("Authorization-Token") &&
    localStorage.getItem("expires_at")
  ) {
    // Check whether the current time is past the Access Token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    // set localAuthTokenCheck true if unexpired / false if expired
    routerAuthCheck = new Date().getTime() < expiresAt;
  }

  store.commit("AUTH_SUCCESS", routerAuthCheck);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is Authenticated
    if (routerAuthCheck) {
      // user is Authenticated

      // user is Admin - allow access
      let profile = store.getters.getProfile;
      let is_admin = profile ? profile.is_admin : false;
      if (is_admin) next();
      else {
        // route doesn't require rights - allow access
        if (!to.matched.some(record => record.meta.requiresRights)) next();
        else {
          // user has rights to route - allow access
          let rights = store.getters.getRights;
          if (rights.indexOf(to.name.toLowerCase()) != -1) next();
          // user has no rights to route - deny access, redirect to orders
          else next("/orders");
        }
      }
    } else {
      // user is not authenticated - redirect to login
      router.push({
        name: "Login"
      });
    }
  } else {
    next();
  }
});

export default router;
